module.exports = __webpack_public_path__ + "static/img/AdobeStock_317642058.785396d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_design/AdobeStock_317642058.png
// module id = 2
// module chunks = 1